import { IErrorProps } from "../../models";

interface ErrorListProps {
  errorListGlobal: IErrorProps[]; // Replace any with the actual type of the items in the array
  setOpenDialogServerError: (value: boolean) => void;
  setErrorListGlobal: (value: IErrorProps[]) => void; // Replace any with the actual type IErrorProps
}
export const serverErrorClose = (props: ErrorListProps) => {
  props.setOpenDialogServerError(false);
  props.setErrorListGlobal(
    props.errorListGlobal.filter(
      (x) =>
        !(
          // Used && instead of || to ensure that an item is filtered out only if errorCode is null, 400, or undefined.
          (
            x.errorCode !== null &&
            x.errorCode !== 400 &&
            x.errorCode !== undefined
          )
        )
    )
  );
};
